export type AreaStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type AreaDto = {
  uuid: string;
  code: string;
  name: string;
  description: string | null;
  status: AreaStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type AreaRequest = {
  code: string;
  name: string;
  description: string | null;
};

export type AreaListQuery = {
  code?: string;
  name?: string;
  description?: string;
  enabled?: boolean;
  page?: number;
  size?: number;
  sort?: string;
};

export type AreaListResult = {
  items: AreaDto[];
  total: number;
};

export type AreaStatusLabel = 'Activo' | 'Inactivo';

export function areaEnabled(dto: AreaDto): boolean {
  return areaStatusLabel(dto) === 'Activo';
}

export function areaStatusLabel(dto: AreaDto): AreaStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): AreaStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}
